<template>
  <div class="single-transaction-modal">
    <h4 class="modal-title mb-30">{{ data.title }} # {{ data.transactionId }}</h4>
    <div class="row">
      <div class="col d-flex align-items-center">
        <div class="pr-15"><i class='uil uil-mid uil-money-insert lighter-text-color'></i></div>
        <div>
          <p class="lighter-text-color mb-0">Sender</p>
          <h6 class="mb-0">{{ data.sender }}</h6>
        </div>
      </div>
      <div class="col d-flex align-items-center">
        <div class="pr-15"><i class='uil uil-mid uil-money-withdraw lighter-text-color'></i></div>
        <div>
          <p class="lighter-text-color mb-0">Recipient</p>
          <h6 class="mb-0">{{ data.recipient }}</h6>
        </div>
      </div>
    </div>
    <div class="transaction-price">
      <div class="row">
        <div class="col currency-symbol">Transaction amount</div>
        <div class="col text-right">EUR <strong>{{data.amount}}</strong></div>
      </div>
    </div>

    <div class="p-15 mt-5">
      <div class="row">
        <div class="col currency-symbol">Date</div>
        <div class="col text-right">{{ data.date }}</div>
      </div>
    </div>

    <div class="p-15 mt-5">
      <div class="row">
        <div class="col currency-symbol">Transaction ID</div>
        <div class="col text-right">{{ data.transactionId }}</div>
      </div>
    </div>

    <div class="p-15 mt-5">
      <div class="row">
        <div class="col currency-symbol">Invoice Reference</div>
        <div class="col text-right">{{ data.invoiceRef }}</div>
      </div>
    </div>

    <div class="p-15 mt-5">
      <button class="btn btn-outline mr-10">View details</button>
      <button class="btn btn-plain" @click="close">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'single-transaction-modal',
  props: {
    data: Object
  },
  methods: {
    close() {
      this.$store.commit('showHideSideModal', {
        show: false,
        component: '',
        payload: null
      })
    },
  }
}
</script>
